// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  height: 100%;
  display: block;
}

ion-grid {
  padding: 0.375rem 0.375rem 0.75rem;
  background-color: #ffffff;
  margin: 0;
  border-radius: 0.25rem;
  height: 100%;
}
ion-grid::ng-deep .swiper .swiper-slide {
  flex-direction: column;
}
ion-grid::ng-deep .swiper .swiper-pagination {
  top: 8.125rem;
  bottom: unset;
  line-height: 0;
}
ion-grid::ng-deep .swiper .swiper-pagination .swiper-pagination-bullet {
  border: 1.45px solid var(--ion-color-secondary) !important;
  background: none;
  opacity: 1;
  width: 0.75rem;
  height: 0.75rem;
}
ion-grid::ng-deep .swiper .swiper-pagination .swiper-pagination-bullet-active {
  background: var(--ion-color-secondary);
}
ion-grid .promo-image {
  width: 100%;
  height: 7.06rem;
  object-fit: cover;
}
ion-grid .name {
  margin: 2.5rem 0 2.31rem;
}
ion-grid .details {
  position: absolute;
  bottom: 0.169rem;
  right: 0.925rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.17rem;
  text-align: left;
  color: #333333;
  text-decoration: underline;
}

@media screen and (min-width: 751px) and (max-width: 991px) {
  ion-grid .promo-image {
    height: calc((100vw - 40px) / 2.7) !important;
  }
  ion-grid::ng-deep .swiper .swiper-pagination {
    top: calc((100vw - 40px) / 2.7 + 0.75rem) !important;
  }
}
@media screen and (max-width: 991px) {
  ion-grid {
    padding: 0.25rem 0.25rem 0.5rem;
  }
  ion-grid .promo-image {
    height: calc((100vw - 40px) / 2.34);
  }
  ion-grid::ng-deep .swiper .swiper-pagination {
    top: calc((100vw - 40px) / 2.34 + 0.75rem);
  }
  ion-grid::ng-deep .swiper .swiper-pagination .swiper-pagination-bullet {
    border-width: 1px;
    width: 0.5rem;
    height: 0.5rem;
  }
  ion-grid .name {
    margin: 1.75rem 0 1.625rem;
  }
  ion-grid .details {
    font-size: 0.688rem;
    line-height: 0.81rem;
    bottom: 0.125rem;
    right: 0.625rem;
  }
}
@media screen and (max-width: 575px) {
  ion-grid {
    padding: 0.25rem 0.25rem 0.25rem;
  }
  ion-grid .name {
    margin-top: 1.5rem;
    margin-bottom: 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/promotions-section/promotions-section.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,cAAA;AACJ;;AACA;EACI,kCAAA;EACA,yBAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;AAEJ;AACQ;EACI,sBAAA;AACZ;AAEQ;EACI,aAAA;EACA,aAAA;EACA,cAAA;AAAZ;AAEY;EACI,0DAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAAhB;AAGY;EACI,sCAAA;AADhB;AAMI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;AAJR;AAOI;EACI,wBAAA;AALR;AAOI;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,0BAAA;AALR;;AAUA;EAEQ;IACI,6CAAA;EARV;EAYU;IACI,oDAAA;EAVd;AACF;AAeA;EACI;IACI,+BAAA;EAbN;EAeM;IACI,mCAAA;EAbV;EAiBU;IACI,0CAAA;EAfd;EAiBc;IACI,iBAAA;IACA,aAAA;IACA,cAAA;EAflB;EAmBM;IACI,0BAAA;EAjBV;EAmBM;IACI,mBAAA;IACA,oBAAA;IACA,gBAAA;IACA,eAAA;EAjBV;AACF;AAqBA;EACI;IACI,gCAAA;EAnBN;EAqBM;IACI,kBAAA;IACA,sBAAA;EAnBV;AACF","sourcesContent":[":host {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n}\r\nion-grid {\r\n    padding: 0.375rem 0.375rem 0.75rem;\r\n    background-color: #ffffff;\r\n    margin: 0;\r\n    border-radius: 0.25rem;\r\n    height: 100%;\r\n\r\n    &::ng-deep .swiper {\r\n        .swiper-slide {\r\n            flex-direction: column;\r\n        }\r\n        \r\n        .swiper-pagination {\r\n            top: 8.125rem;\r\n            bottom: unset;\r\n            line-height: 0;\r\n\r\n            .swiper-pagination-bullet {\r\n                border: 1.45px solid var(--ion-color-secondary) !important;\r\n                background: none;\r\n                opacity: 1;\r\n                width: 0.75rem;\r\n                height: 0.75rem;\r\n            }\r\n            \r\n            .swiper-pagination-bullet-active {\r\n                background: var(--ion-color-secondary);\r\n            }\r\n        }\r\n    }\r\n\r\n    .promo-image {\r\n        width: 100%;\r\n        height: 7.06rem; \r\n        object-fit: cover;\r\n    }\r\n\r\n    .name {\r\n        margin: 2.5rem 0 2.31rem;\r\n    }\r\n    .details {\r\n        position: absolute;\r\n        bottom: 0.169rem;\r\n        right: 0.925rem;\r\n        font-size: 1rem;\r\n        font-weight: 400;\r\n        line-height: 1.17rem;\r\n        text-align: left;\r\n        color: #333333;\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width: 751px) and (max-width: 991px) {\r\n    ion-grid {\r\n        .promo-image {\r\n            height: calc((100vw - 40px) / 2.7) !important;\r\n        }\r\n\r\n        &::ng-deep .swiper {\r\n            .swiper-pagination {\r\n                top: calc((100vw - 40px) / 2.7 + 0.75rem) !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    ion-grid {\r\n        padding: 0.25rem 0.25rem 0.5rem;\r\n\r\n        .promo-image{\r\n            height: calc((100vw - 40px) / 2.34);\r\n        }\r\n\r\n        &::ng-deep .swiper {\r\n            .swiper-pagination {\r\n                top: calc((100vw - 40px) / 2.34 + 0.75rem);\r\n    \r\n                .swiper-pagination-bullet {\r\n                    border-width: 1px;\r\n                    width: 0.5rem;\r\n                    height: 0.5rem;\r\n                }\r\n            }\r\n        }\r\n        .name {\r\n            margin: 1.75rem 0 1.625rem;\r\n        }\r\n        .details {\r\n            font-size: 0.688rem;\r\n            line-height: 0.81rem;\r\n            bottom: 0.125rem;\r\n            right: 0.625rem;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 575px) {\r\n    ion-grid {\r\n        padding: 0.25rem 0.25rem 0.25rem;\r\n\r\n        .name {\r\n            margin-top: 1.5rem;\r\n            margin-bottom: 0.25rem;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
